
import { useMap } from "react-leaflet";
import { useEffect, useRef } from 'react';

export default function MapInteraction(props) {
    const map = useMap()
    useDidMountEffect(() => {
        map.flyToBounds(props.mapBounds, {
            animate: true,
            duration: 2
        })
    }, [props.mapBounds])

    return null
}

const useDidMountEffect = (func, deps) => {
    // Prevents re-render on inital load
    const didMount = useRef(false);
    useEffect(() => {
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
}